import { useState } from 'react';
import { ExtractionType, ImportDescriptorIdType } from '../../../../types';
import {
    useImportTableStoreReportsEditMode,
    useImportTableStoreReportsMap,
} from '../../context/importTableContext';
import DescriptorCell from './components/descriptorCell';
import DescriptorScaleCell from './components/descriptorScaleCell';
import DescriptorTypeCell from './components/descriptorTypeCell';
import ImportTableRow from './components/importTableRow';
import ReportCell from './components/reportCell';
import SingFlipCell from './components/signFlipCell';
import { TABLE_HEADER_REPORT_PROPS } from './constants';
import './styles.css';
import { getTableHeaderRowSpan } from './utils';

type ImportTablePropsType = {
    extraction: ExtractionType;
    imagePopupOpen: boolean;
};
const Table = ({ extraction, imagePopupOpen }: ImportTablePropsType) => {
    const [highlightedVariables, setHighlightedVariables] = useState<ImportDescriptorIdType[]>([]);

    const handleHighLightCalcVariables = (ids: ImportDescriptorIdType[]) => {
        setHighlightedVariables(ids);
    };

    const handleUnhighLightCalcVariables = () => {
        return setHighlightedVariables([]);
    };

    const areReportsBeingEdited = useImportTableStoreReportsEditMode();
    const reportsMap = useImportTableStoreReportsMap();
    //TODO: Look at correct structure for the rowspans this is not the correct one
    return (
        <table className="extraction-table import-table">
            <thead>
                <tr>
                    <th rowSpan={getTableHeaderRowSpan(areReportsBeingEdited)}>Imported Descriptors</th>
                </tr>
                <tr>
                    <th rowSpan={getTableHeaderRowSpan(areReportsBeingEdited)}>Type</th>
                </tr>
                <tr>
                    <th rowSpan={getTableHeaderRowSpan(areReportsBeingEdited)}>Scale</th>
                </tr>
                {areReportsBeingEdited && (
                    <tr>
                        <th rowSpan={getTableHeaderRowSpan(areReportsBeingEdited)}>Sign</th>
                    </tr>
                )}
                {TABLE_HEADER_REPORT_PROPS.map((prop) => {
                    return (
                        <tr key={prop}>
                            {extraction.importTable.reports.map((r, i) => {
                                return <th key={i}>{r[prop]}</th>;
                            })}
                        </tr>
                    );
                })}
            </thead>
            <tbody>
                {extraction.importTable.descriptors.map((importDescriptor, descriptorIndex) => {
                    const importDescriptorId = importDescriptor.id;
                    return (
                        <ImportTableRow
                            key={importDescriptorId}
                            descriptorId={importDescriptorId}
                            handleHighLightCalcVariables={handleHighLightCalcVariables}
                            handleUnhighLightCalcVariables={handleUnhighLightCalcVariables}
                            highlightedVariables={highlightedVariables}
                        >
                            <DescriptorCell descriptorId={importDescriptorId} />
                            <DescriptorTypeCell descriptorId={importDescriptorId} />
                            <DescriptorScaleCell
                                descriptorId={importDescriptorId}
                                generalScale={extraction.metadata.scaleFactor.value}
                            />
                            {areReportsBeingEdited && <SingFlipCell descriptorId={importDescriptorId} />}
                            {Object.values(reportsMap).map((report, reportIndex) => {
                                return (
                                    <ReportCell
                                        key={report.id}
                                        descriptorId={importDescriptorId}
                                        reportId={report.id}
                                        descriptorIndex={descriptorIndex}
                                        reportIndex={reportIndex}
                                        imagePopupOpen={imagePopupOpen}
                                    />
                                );
                            })}
                        </ImportTableRow>
                    );
                })}
            </tbody>
        </table>
    );
};

export default Table;
